export default "__VITE_PUBLIC_ASSET__12b18315__"